
import { Options, Vue } from "vue-class-component";
import MTextField from "@/components/form/MTextField.vue";

@Options({
  components: {
    MTextField
  },
  emits: ["input", "enter", "change"],
  props: {
    choices: Array,
    placeholder: String,
    value: String,
    invalidMessage: String,
    choiceForManual: String
  }
})
export default class MTextSelector extends Vue {
  name = "textSelector";
  placeholder = "";
  value = "";
  invalid = false;
  invalidMessage = "入力（にゅうりょく）してください";
  choices: string[] = [];
  choiceForManual = "じぶんでかく";
  isManual = false;
  entered = false;

  setThoughtPreset(preset: string) {
    if (this.isManual) {
      this.isManual = false;
    }
    this.$emit("change", preset);
  }

  toggleWritingMode() {
    this.isManual = !this.isManual;
    if (this.isManual) {
      this.entered = false;
    }
    this.$emit("change", "");
  }

  getDynamicCss(preset: string) {
    if (
      (preset === this.choiceForManual && this.isManual) ||
      (preset !== this.choiceForManual &&
        this.value === preset &&
        !this.isManual)
    ) {
      return {
        "border-primary-500": true,
        "bg-primary-500": true,
        "text-white": true,
        "cursor-pointer": true
      };
    } else {
      return {
        "border-gray-400": true,
        "text-gray-500": true,
        "cursor-pointer": true
      };
    }
  }

  onManualInputChange(v: string) {
    this.$emit("change", v);
  }

  onBlur() {
    this.$emit("enter");
  }
}
